import { render } from "./SupportScreen.vue?vue&type=template&id=6b6259cc&scoped=true"
import script from "./SupportScreen.vue?vue&type=script&lang=js"
export * from "./SupportScreen.vue?vue&type=script&lang=js"

import "./SupportScreen.vue?vue&type=style&index=0&id=6b6259cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6259cc"]])

export default __exports__